export default __webpack_public_path__ + "static/media/left-top.2aff7a34.png";